export default "__VITE_ASSET__CcD9h8HN__"